import { render, staticRenderFns } from "./CassaList.vue?vue&type=template&id=ced06cb8&"
import script from "./CassaList.vue?vue&type=script&lang=ts&"
export * from "./CassaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports